export default "__VITE_ASSET__CY7F0XZD__"